export const environment = {
  production: false,
  apiBase: 'https://api.mavenepm.com',
  apiVersion: 'v1',
  xApiToken: '12OqsaXd9cxl1071Ql5IErt3C74oo5kEG',
  appName: 'provider',
  appVersion: '3.0.1',
  SOCKET_ENDPOINT: 'https://websocket.mavenepm.com/',
  role: 'provider',
  appLogo: 'eagle',
  teleconsultLinks: {
    provider: 'https://teleconsult.mavenepm.com/teleconsult-v2/',
    client: 'https://teleconsult.mavenepm.com/consult/',
  },
};
